var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTrashIconGrid(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 5.03159H4.16667M4.16667 5.03159H17.5M4.16667 5.03159V16.3158C4.16667 16.7625 4.34226 17.1909 4.65482 17.5067C4.96738 17.8226 5.39131 18 5.83333 18H14.1667C14.6087 18 15.0326 17.8226 15.3452 17.5067C15.6577 17.1909 15.8333 16.7625 15.8333 16.3158V5.03159H4.16667ZM6.66667 5.03159V3.68421C6.66667 3.23753 6.84226 2.80914 7.15482 2.49329C7.46738 2.17744 7.89131 2 8.33333 2H11.6667C12.1087 2 12.5326 2.17744 12.8452 2.49329C13.1577 2.80914 13.3333 3.23753 13.3333 3.68421V5.03159M8.33333 9.24211V14.2947M11.6667 9.24211V14.2947",
    stroke: "#99A4B1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashIconGrid);
export default __webpack_public_path__ + "static/media/trash-icon-grid.9ee5b39e6051f1a0ba5d159e0992f2c5.svg";
export { ForwardRef as ReactComponent };